import { useMemo, useState } from 'react';
import { IMenuBulkAction } from '~/Models/interfaces/menuAction.models';
import { IListAction } from '../../ListToolbar/ListAction.models';

export const useFitoListSelection = ({
  query,
  bulkActions,
  defaultSelectedIds,
  onSelect,
}: {
  query: { [name: string]: any };
  bulkActions?: IMenuBulkAction[];
  defaultSelectedIds?: string[];
  onSelect?: (id: string | string[], checked?: boolean) => void;
}) => {
  const [selectedIds, setSelectedIds] = useState(defaultSelectedIds || []);
  // actions
  const Actions: IListAction[] = useMemo(() => [], []);
  const BulkActions: IListAction[] = useMemo(
    () =>
      bulkActions?.map((action) => ({
        title: action.name,
        onClick: () => action.onClick({ ...query, selectedIds }),
      })) || [],
    [query, bulkActions],
  );

  // selecting
  const OnSelect = (id: string | string[], checked = false) => {
    const listOfIds = typeof id === 'string' ? [id] : id;
    if (checked) {
      setSelectedIds([
        ...selectedIds,
        ...listOfIds?.filter((selectedId) => !selectedIds?.includes(selectedId.toString())),
      ]);
    } else {
      setSelectedIds(selectedIds?.filter((selectedId) => !id?.includes(selectedId.toString())));
    }
    onSelect?.(id, checked);
  };

  return {
    Actions,
    BulkActions,
    OnSelect,
    selectedIds,
  };
};
